import * as React from "react";
import { userHasPermission } from "@eduviaos/shared";
import { useAuth } from "@/auth/AuthProvider";

export interface AttendanceAuthoringGate {
  canViewAttendance: boolean;
  canManageAttendance: boolean;
  missingView: boolean;
}

export function useCanManageAttendance(): AttendanceAuthoringGate {
  const { user } = useAuth();
  return React.useMemo<AttendanceAuthoringGate>(() => {
    if (!user) {
      return { canViewAttendance: false, canManageAttendance: false, missingView: false };
    }
    const overrides = user.permission_overrides ?? [];
    const canView = userHasPermission(
      user.role,
      overrides,
      "view_attendance",
      user.permission_mode ?? "additive",
    );
    const canManage = userHasPermission(
      user.role,
      overrides,
      "manage_attendance",
      user.permission_mode ?? "additive",
    );
    return {
      canViewAttendance: canView,
      canManageAttendance: canManage,
      missingView: !canView,
    };
  }, [user]);
}
